interface AccessDeniedProps {
  onLogout: () => void;
}

function AccessDenied({ onLogout }: AccessDeniedProps) {
  return (
    <div className="form-container" style={{ textAlign: 'center', marginTop: '4rem' }}>
      <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>Access Denied</h2>
      <p style={{ color: '#666', marginBottom: '2rem' }}>
        You do not have admin access. Please contact an administrator if you believe this is an error.
      </p>
      <button
        onClick={onLogout}
        className="btn btn-primary"
        style={{ padding: '0.75rem 2rem' }}
      >
        Logout
      </button>
    </div>
  );
}

export default AccessDenied;
